import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Deletes a product by its ID using the centralized API call utility.
 *
 * @param {string} id - The ID of the product to delete.
 * @returns {Promise<Object>} - The response data from the server.
 * @throws Will throw an error if the request fails.
 * 
 * @author Susovan Mishra
 */
const deleteProduct = async (id) => {
  return await apiCall(`${AUTH_ROUTES.PRODUCTS_API_ENDPOINT}/${id}`, {
    method: "DELETE",
  });
};

export default deleteProduct;
